/**
 * Datos del titular del sitio que aparecen en el footer y en las páginas
 * legales (Términos y Aviso de privacidad).
 *
 * TODO(legal): reemplazar con los datos reales antes de publicar. El aviso de
 * privacidad de la LFPDPPP exige identificar al responsable, su domicilio y un
 * medio de contacto; los términos deben decir con quién contrata el usuario.
 */
export const SITE = {
    name: "Tiendify",
    domain: "tiendify.io",
    url: "https://tiendify.io",

    // Datos del responsable — PENDIENTES DE LLENAR
    legalName: "Isidro Antonio Sanchez Aguirre",
    rfc: "AUSI900728TM9",
    address: "CALLE DIAMANTE 2820 INT 3, VERDE VALLE, GUADALAJARA, JALISCO",
    contactEmail: "soporte@tiendify.io",
    privacyEmail: "soporte@tiendify.io",

    // Fecha de la última actualización de los documentos legales.
    legalUpdatedAt: "10 de agosto de 2026",
};
